<template>
  <div class="page-box">
    <span class="time">
      剩余时间:
      <van-count-down ref="aaa" :time="time" @change="timeChange"/>
    </span>
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { Dialog,Toast } from 'vant';
export default {
  beforeRouteEnter(to, from, next) {
    if(to.query.filingsRecordCode && localStorage.getItem('userAgent')){
      let loading = Toast.loading({
        duration:0,
        overlay: true,
        forbidClick: true,
      });
      // 每次进入前，查看核验进度
      window.$apis.filingServer.queryVerifing({
        filingsRecordCode: to.query.filingsRecordCode,
        userAgent: localStorage.getItem('userAgent'),
      }).then(res => {
        loading.clear();
        if (res['code'] == 0 && res['data']['verifyToken'] && res['data']['addDate']) {
          localStorage.setItem('verifyToken',res['data']['verifyToken']);
          next((vm)=>{
            vm.$store.dispatch('filingStore/addDetails',res['data']);
            vm.time = (new Date(res['data']['addDate']).getTime())+(30 * 60 * 1000) - new Date().getTime()
          });
        } else {
          Dialog({
            title: '提示',
            message: res['msg']?res['msg']:'核验过期,请重新扫码发起核验',
            confirmButtonText:'好的',
            confirmButtonColor:'#4285f5',
          }).then(() => {
            next(`/filing/start?filingsRecordCode=${to.query.filingsRecordCode || from.query.filingsRecordCode}`)
          }).catch(() => {
          });
        }
      });
    }else{
      Dialog({
        title: '提示',
        message: '二维码已失效请重新扫码',
        confirmButtonColor:'#4285f5',
      }).then(() => {
        next(`/filing/start?filingsRecordCode=${to.query.filingsRecordCode || from.query.filingsRecordCode}`)
      });
    }
  },
  data() {
    return {
      info: this.$store.getters["filingStore/getInfo"],
      time:null,
    };
  },
  mounted() {
    document.title = '上传核准证件及验证真实性';
  },
  methods: {
    timeChange(time) {
      let {minutes,seconds} = time;
      if((minutes*60+seconds)<=0){
        this.$dialog.alert({
          message: '核验超时，请重新开始',
          confirmButtonText:'好的',
          confirmButtonColor:'#4285f5',
        })
        .then(() => {
          this.$router.push({
            path: '/filing/start',
            query:{
              filingsRecordCode: this.$route.query.filingsRecordCode
            }
          });
        });
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.page-box{
  .time{
    position: absolute;
    right: 50px;
    top: 45px;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 28px;
    color: #333;
    /deep/ .van-count-down{
      color: #333;
      font-size: 24px;
    }
  }
}
</style>
